import { render, staticRenderFns } from "./chooseSubject.vue?vue&type=template&id=90a91a14&scoped=true&"
import script from "./chooseSubject.vue?vue&type=script&lang=js&"
export * from "./chooseSubject.vue?vue&type=script&lang=js&"
import style0 from "./chooseSubject.vue?vue&type=style&index=0&id=90a91a14&scoped=true&lang=less&"
import style1 from "./chooseSubject.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a91a14",
  null
  
)

export default component.exports